module.exports = __webpack_public_path__ + "img/remove-image.7402ee48.svg";